import axios from 'axios';
import { BACKEND_URL } from '../utils/constants';

const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  register: (data) => api.post('/register', data),
  login: (data) => api.post('/login', data),
  verifyOtp: (otp) => api.post('/otp/verify', { otp }),
  resendOtp: () => api.post('/otp/resend'),
  getReferralInfo: () => api.get('/referral-info'),
  getPartnerPreferences: () => api.get('/partner-preferences'),
  savePartnerPreferences: (data) => api.post('/partner-preferences', data),
  getKundli: () => api.get('/kundli'),
  saveBirthDetails: (data) => api.post('/kundli/birth-details', data),
  generateKundli: () => api.post('/kundli/generate'),
  uploadKundli: (formData) => api.post('/kundli/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getProfile: () => api.get('/profile'),
  logout: () => api.post('/logout'),
  getProfiles: (params) => api.get(`/profiles?${params}`),
  getProfileById: (id) => api.get(`/profiles/${id}`),
  getEditProfile: () => api.get('/edit-profile'),
  updateProfile: (data) => api.post('/edit-profile', data),
  uploadPhoto: (formData) => api.post('/edit-profile/photos', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletePhoto: (photoId) => api.delete(`/edit-profile/photos/${photoId}`),
  setPrimaryPhoto: (photoId) => api.post(`/edit-profile/photos/${photoId}/primary`),
  toggleLike: (toProfileId, type) => api.post(`/likes/${toProfileId}`, { type }),
  getLikeStatus: (toProfileId) => api.get(`/likes/${toProfileId}/status`),
  sendInterest: (toProfileId) => api.post(`/interests/${toProfileId}`),
  getInterestStatus: (toProfileId) => api.get(`/interests/${toProfileId}/status`),
  getReceivedInterests: () => api.get('/interests/received'),
  getSentInterests: () => api.get('/interests/sent'),
  respondInterest: (interestId, action) => api.post(`/interests/${interestId}/respond`, { action }),
  getShortlists: () => api.get('/shortlists'),
  toggleShortlist: (profileId) => api.post(`/shortlists/${profileId}`),
  getShortlistStatus: (profileId) => api.get(`/shortlists/${profileId}/status`),
  getWalletBalance: () => api.get('/wallet/balance'),
  rechargeWallet: (amount) => api.post('/wallet/recharge', { amount }),
  getTransactions: () => api.get('/wallet/transactions'),
  unlockContact: (profileId) => api.post(`/wallet/unlock/${profileId}`),
  getContactStatus: (profileId) => api.get(`/wallet/contact-status/${profileId}`),
  createOrder: (amount) => api.post('/payment/create-order', { amount }),
};
